import { render, staticRenderFns } from "./IndexDoVisual.vue?vue&type=template&id=56968ae2&scoped=true"
import script from "./IndexDoVisual.vue?vue&type=script&lang=js"
export * from "./IndexDoVisual.vue?vue&type=script&lang=js"
import style0 from "./IndexDoVisual.vue?vue&type=style&index=0&id=56968ae2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56968ae2",
  null
  
)

export default component.exports